import { useEffect, useState } from "react";
import { INobatHistory } from "../CompleteCargos";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import { Box } from "@mui/material";
import CanceledCargoCard from "../CanceledCargos/CanceledCargoCard";

export default function CanceledCargos() {
  const [nobatHistories, setNobatHistories] = useState<INobatHistory[]>([]);

  const dispatch = useAppDispatch();

  const {
    trigger: getDriverNobatHistory,
    // isMutating: isgetDriverNobatHistoryMutting,
  } = useSWRMutation(
    [`/Nobat/GetDriverNobatHistory`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setNobatHistories(data);
      },
    }
  );

  useEffect(() => {
    getDriverNobatHistory({
      getActiveNobat: false,
      nobatStatus: 0,
      pageNr: 1,
    });
  }, []);
  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {nobatHistories.map(
        (item) =>
          item.nobatStatus === 7 && (
            <CanceledCargoCard key={item.id} {...item} />
          )
      )}
    </Box>
  );
}
